import { Box, Typography } from '@montugroup/design-system';
import { styled } from '@mui/material';

const Dot = styled('span')(({ theme }) => ({
  display: 'inline-block',
  width: '8px',
  height: '8px',
  borderRadius: '50%',
  background: theme.palette.warning.main,
  margin: '0 2px',
  animation: 'blink 1.4s infinite both',

  '@keyframes blink': {
    '0%': { opacity: 0.2 },
    '20%': { opacity: 1 },
    '100%': { opacity: 0.2 },
  },
}));

export const ClickAndCollectLoadingLocation = ({ text = 'Searching for locations' }) => {
  return (
    <Box
      sx={{
        width: '100%',
        height: 250,
        bgcolor: (theme) => theme.palette.divider,
        borderRadius: 2,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
      }}
    >
      <Typography variant="body1">{text}</Typography>

      <Box>
        <Dot style={{ animationDelay: '0s' }} color="red" />
        <Dot style={{ animationDelay: '0.2s' }} />
        <Dot style={{ animationDelay: '0.4s' }} />
        <Dot style={{ animationDelay: '0.6s' }} />
        <Dot style={{ animationDelay: '0.8s' }} />
        <Dot style={{ animationDelay: '1s' }} />
      </Box>
    </Box>
  );
};
